import { Toaster } from "react-hot-toast";

const Toast = () => {
  return (
    <>
      <Toaster position="top-right" />
    </>
  );
};

export default Toast;
